import React from 'react';
import {
  LayoutDashboard,
  Users,
  GraduationCap,
  UserRoundCog,
  CalendarDays,
  BookOpen,
  FileText,
  Settings,
  FolderOpen,
  BarChart3,
  Award,
  BriefcaseBusiness,
  X
} from 'lucide-react';
import './AdminSidebar.css';


const AdminSidebar = ({
  activeMenu = 'dashboard',
  setActiveMenu,
  setShowSettings,
  t = {},
  isOpen = false,
  onClose
}) => {

  const logoSrc = `${process.env.PUBLIC_URL}/images/logo.png`;

  const menuItems = [
    {
      id: 'dashboard',
      name: t.sidebarDashboard || 'Главная',
      icon: <LayoutDashboard size={20} strokeWidth={2.2} />
    },
    {
      id: 'users',
      name: t.sidebarUsers || 'Пользователи',
      icon: <Users size={20} strokeWidth={2.2} />
    },
    {
      id: 'teachers',
      name: t.sidebarTeachers || 'Преподаватели',
      icon: <UserRoundCog size={20} strokeWidth={2.2} />
    },
    {
      id: 'schedule',
      name: t.sidebarSchedule || 'Расписание',
      icon: <CalendarDays size={20} strokeWidth={2.2} />
    },
    {
      id: 'plans',
      name: t.sidebarPlans || 'Нагрузка',
      icon: <BookOpen size={20} strokeWidth={2.2} />
    },
    {
      id: 'programs',
      name: t.sidebarPrograms || 'Рабочие программы',
      icon: <FileText size={20} strokeWidth={2.2} />
    },

    {
      id: 'reports',
      name: t.sidebarReports || 'Отчеты',
      icon: <BarChart3 size={20} strokeWidth={2.2} />
    },

  ];

  const handleMenuClick = (menuId) => {
    if (typeof setActiveMenu === 'function') {
      setActiveMenu(menuId);
    }

    if (typeof setShowSettings === 'function') {
      setShowSettings(false);
    }
  };

  const handleSettingsClick = () => {
    if (typeof setShowSettings === 'function') {
      setShowSettings(true);
    }

    if (typeof setActiveMenu === 'function') {
      setActiveMenu('settings');
    }
  };

  return (
    <>
      {isOpen && (
        <div className="mobile-menu-overlay" onClick={onClose} />
      )}
      <aside className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-top drawer-header-top">
          <div className="logo">
            <img
              src={logoSrc}
              alt={t.logoAlt || 'Кафедра информационных технологий'}
              className="logo-image"
            />

            <div className="logo-text">
              <h2>
                {t.sidebarLogoTitle || 'Кафедра информационных технологий'}
              </h2>
              <p>{t.sidebarLogoSubtitle || 'Панель администратора'}</p>
            </div>
          </div>
          <button type="button" className="drawer-close-btn" onClick={onClose} title="Закрыть">
            <X size={20} />
          </button>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <button
              key={item.id}
              className={`nav-item ${activeMenu === item.id ? 'active' : ''}`}
              onClick={() => handleMenuClick(item.id)}
              type="button"
              title={item.name}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-name">{item.name}</span>
            </button>
          ))}
        </nav>
      </aside>
    </>
  );

};

export default AdminSidebar;